import * as React from 'react'
import styled from 'styled-components'
import Svg from './Svg'

function BaseComponent(props: any) {
  return (
    <Svg
      width={15}
      height={15}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.05 2.75a.55.55 0 10-1.1 0v9.5a.55.55 0 001.1 0v-9.5zm2.683-.442A.5.5 0 005 2.75v9.5a.5.5 0 00.733.442l9-4.75a.5.5 0 000-.884l-9-4.75zM6 11.42V3.579L13.429 7.5l-7.43 3.92z"
        fill="currentColor"
      />
    </Svg>
  )
}

const SvgResume = styled(BaseComponent)`
  outline: none;
`
export default SvgResume
